// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"631f5369","312":"98fd6a11","502":"ac23db32","509":"631f5369","677":"4407c092","709":"42ed169e","837":"04ba8113","845":"fa50905f","937":"631f5369"}[chunkId] + ".chunk.css";
};